import { Button } from '@/components/ui/button';
import { UI_INVARIANTS } from '../../config/ui-invariants';
import { Loader2 } from 'lucide-react';

/**
 * PrimaryButton - Brand primary button component
 * 
 * Uses brand-primary token color (Midnight Blue)
 * Supports disabled and loading states via BUTTON_STATE contract
 * 
 * @param {React.ReactNode} children - Button content
 * @param {boolean} loading - Show loading state (disabled + spinner)
 * @param {boolean} disabled - Disabled state
 * @param {string} className - Additional classes for local overrides (optional)
 * @param {object} props - Additional Button props (onClick, etc.)
 * 
 * @example
 * // Simple usage
 * <PrimaryButton onClick={handleClick}>
 *   Upload
 * </PrimaryButton>
 * 
 * // With loading state
 * <PrimaryButton loading={saving}>
 *   Save Changes
 * </PrimaryButton>
 * 
 * // With disabled state
 * <PrimaryButton disabled={!isValid}>
 *   Submit
 * </PrimaryButton>
 */
export function PrimaryButton({ children, loading = false, disabled = false, className = '', ...props }) {
    const isDisabled = disabled || loading;

    return (
        <Button
            className={`bg-brand-primary hover:bg-brand-primary-hover text-white shadow-md font-medium ${className}`}
            disabled={isDisabled}
            style={{
                opacity: loading ? UI_INVARIANTS.BUTTON_STATE.LOADING.opacity : undefined,
                cursor: loading ? UI_INVARIANTS.BUTTON_STATE.LOADING.cursor : undefined,
                transition: `opacity ${UI_INVARIANTS.BUTTON_STATE.TRANSITION_DURATION}`,
            }}
            {...props}
        >
            {loading && <Loader2 className="h-4 w-4 animate-spin" />}
            {children}
        </Button>
    );
}
